import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, CalendarDays, CalendarClock, LogOut, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const NavItem = ({ to, icon: Icon, children, testid }) => {
  const { pathname } = useLocation();
  const active = pathname === to || (to !== "/" && pathname.startsWith(to));
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-all ${
        active
          ? "bg-[#6E5AA0] text-white shadow-sm"
          : "text-[#2D322F] hover:bg-[#F0EBF6]"
      }`}
    >
      <Icon size={18} strokeWidth={1.75} />
      <span className="font-medium">{children}</span>
    </Link>
  );
};

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#FBFBF9]">
      <aside className="w-64 border-r border-[#E8E9E6] bg-white flex flex-col">
        <div className="px-6 py-7 border-b border-[#E8E9E6]">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#6E5AA0] flex items-center justify-center">
              <Sparkles className="text-white" size={18} strokeWidth={2} />
            </div>
            <div>
              <div className="font-heading text-lg font-semibold ink leading-none">Ellis Path</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-[#6B726F] mt-1">Special ed assistant</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          <NavItem to="/" icon={LayoutDashboard} testid="nav-dashboard">Dashboard</NavItem>
          <NavItem to="/students" icon={Users} testid="nav-students">Students</NavItem>
          <NavItem to="/schedule" icon={CalendarClock} testid="nav-schedule">Schedule</NavItem>
          <NavItem to="/meetings" icon={CalendarDays} testid="nav-meetings">Meetings</NavItem>
        </nav>

        <div className="p-4 border-t border-[#E8E9E6]">
          <div className="px-2 pb-3">
            <div className="text-sm font-medium ink truncate" data-testid="user-name">{user?.name}</div>
            <div className="text-xs ink-muted truncate">{user?.email}</div>
          </div>
          <Button
            variant="ghost"
            onClick={() => { logout(); navigate("/login"); }}
            className="w-full justify-start text-[#6B726F] hover:text-[#BA6356]"
            data-testid="logout-button"
          >
            <LogOut size={16} className="mr-2" /> Sign out
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="max-w-7xl mx-auto px-8 py-10">{children}</div>
      </main>
    </div>
  );
}
